"use client";

import type { ReactNode } from "react";
import { ChatInput } from "./chat-input";
import { SuggestionChips } from "./suggestion-chips";

interface GreetingScreenProps {
  input: string;
  onInputChange: (value: string) => void;
  onSend: () => void;
  onStop: () => void;
  isLoading: boolean;
  onSuggestionSelect: (prompt: string) => void;
  /** Headline above the composer. Absent ⇒ no heading is rendered. */
  greeting?: ReactNode;
  suggestions?: { label: string; prompt: string }[];
}

export function GreetingScreen({
  input,
  onInputChange,
  onSend,
  onStop,
  isLoading,
  onSuggestionSelect,
  greeting,
  suggestions,
}: GreetingScreenProps) {
  return (
    // min-h-0 + overflow-y-auto give the greeting branch its own scroll path: ChatAppShell bounds
    // the surface to h-dvh with overflow-hidden, and only the transcript branch (MessageList) ships
    // a scroller, so on a short landscape viewport a grown composer or a wrapped intent greeting had
    // no way to reach the chips or the send control. The inner block centres with `m-auto` rather
    // than the parent's justify-center, because auto margins collapse when the content overflows
    // instead of pushing its top above the scroll origin where it cannot be reached.
    <div className="flex flex-1 min-h-0 flex-col overflow-y-auto px-4">
      <div className="m-auto w-full max-w-2xl space-y-6">
        {greeting ? (
          <h1 className="font-display text-3xl sm:text-4xl font-semibold text-center tracking-tight">
            {greeting}
          </h1>
        ) : null}
        <ChatInput
          input={input}
          onInputChange={onInputChange}
          onSend={onSend}
          onStop={onStop}
          isLoading={isLoading}
          greeting
        />
        <SuggestionChips onSelect={onSuggestionSelect} suggestions={suggestions} />
      </div>
    </div>
  );
}
